//Importing modules
import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import {checkForGeoShapeField, colorRed} from '../../../../utils/utils'
import InformationIcon from '@material-ui/icons/ErrorOutline';
import InputContent from "./InputContent";

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

function ManualInsertDialog(props){

  let { list, onClose, handleReloadPage, companyKey, userData } = props

  return(
      <Dialog 
      open={props.open} 
      onClose={onClose}
      disableBackdropClick
      maxWidth="lg"
      keepMounted={false}>
          <DialogTitle 
              className={['blueText', "subtitleSize"].join(" ")} 
              onClose={onClose}
          >
              Inserção Manual de Itens
          </DialogTitle>
          <DialogContent >
            {checkForGeoShapeField(list.fields) ?
              <div style={{width: "430px", minHeight:"217px", padding:"8px 24px"}}>
                  <div className="internalCardContainer" style={{display:"flex", height:"40%", justifyContent:"center"}}>
                      <InformationIcon style={{fontSize:"80px",fill: colorRed}}/>
                  </div>
                  <div className={["internalCardContainer", "normalMediumSize"].join(" ")} style={{display:"flex",flexDirection:"column", textAlign:"center", justifyContent:"center"}}>
                     <p>Listas contendo dados do tipo <b>Polígono Geográfico</b> não suportam inserção manual em nossa plataforma.</p>
                     <p>Para adicionar dados a lista, favor utilizar nossa API.</p>
                  </div>
                  <div className="internalCardContainer" style={{display:"flex", justifyContent:"center"}}>
                      <div 
                          className={["button", "standard", "normalText", "normalMediumSize"].join(" ")}
                          onClick={() => {
                              onClose()
                          }} 
                      >
                          VOLTAR À TELA INICIAL 
                      </div>
                  </div>
              </div> :
              <div style={{minHeight: "100px", minWidth: "300px", display:"flex", flexDirection:"column", marginBottom:"20px", width:"max-content",overflow:"hidden", padding:"8px 24px"}}>
                  <InputContent
                    onClose={onClose} 
                    handleReloadPage={handleReloadPage}
                    companyKey={companyKey}
                    userData={userData}
                    list={list}
                  />
              </div>
            }
          </DialogContent>
      </Dialog>
  )
}

export default ManualInsertDialog